import { useContext } from "react";
import { AppContext } from "../App";

import {
  STR_GET_STARTED,
  STR_WELCOME,
  STR_INTRO_2,
} from "../Strings";

import logo_icon from "../assets/logo_icon.png";

export default function Launcher() {

  const appContext = useContext(AppContext);

  return (
    <div
      className="vh-100 d-flex flex-column bg-main-gradient"
      style={{ overflow: "hidden" }}
    >

      {/* Top */}
      <div className="flex-grow-1 d-flex align-items-center justify-content-center px-4">

        <div className="text-center">

          <div
            className="bg-light rounded-circle d-flex align-items-center justify-content-center mx-auto mShadow4"
            style={{
              width: 140,
              height: 140
            }}
          >
            <img
              src={logo_icon}
              alt="BA Rides"
              style={{
                width: 90,
                height: 90,
                objectFit: "contain"
              }}
            />
          </div>

          <h1
            className="mt-4 text-light font-bold"
            style={{ fontSize: "42px" }}
          >
            BA Rides
          </h1>

          <p
            className="text-light mt-3 px-3"
            style={{
              maxWidth: 420,
              margin: "auto",
              opacity: 0.9
            }}
          >
            {STR_INTRO_2[appContext.language]}
          </p>

        </div>

      </div>

      {/* Bottom Card */}
      <div
        className="bg-light rounded-top-5 px-4 py-5 mShadow4"
        style={{
          minHeight: "35vh"
        }}
      >

        <h2 className="font-light text-primary mb-4" style={{ fontSize: "32px" }}>
          {STR_WELCOME[appContext.language]}
        </h2>

        

        <button
          className="btn btn-primary btn-block btn-lg py-3 mb-3"
          onClick={() =>
            appContext.navTo({
              item: "view",
              subItem: "login"
            })
          }
          style={{
            textTransform: "capitalize"
          }}
        >
          {STR_GET_STARTED[appContext.language]}
        </button>

        <button
          className="btn btn-outline-primary btn-block py-3"
          onClick={() => appContext.changeLanguage()}
          style={{
            textTransform: "capitalize"
          }}
        >
          {appContext.language === "en"
            ? "Tumia Kiswahili"
            : "Switch to English"}
        </button>

      </div>

    </div>
  );
}